/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OAuthResponseMode } from './OAuthResponseMode';
import type { OAuthResponseType } from './OAuthResponseType';
export type Body_authorizePost = {
    response_type: OAuthResponseType;
    client_id: string;
    redirect_uri: string;
    scope?: string;
    state?: (string | null);
    nonce?: (string | null);
    code_challenge?: (string | null);
    code_challenge_method?: Body_authorizePost.code_challenge_method;
    id_token_hint?: (string | null);
    response_mode?: (OAuthResponseMode | null);
    resource?: (string | null);
};
export namespace Body_authorizePost {
    export enum code_challenge_method {
        S256 = 'S256',
    }
}

